<!-- 我的账户-个人资料 -->
<template>
  <div class="common-box border-t0 adviserArchives">
    <div style="width:935px;margin:20px auto;">
      <el-form :model="adviserArchivesForm" class="table-normal-form">
        <table class="table-normal-one margin-t15" cellspacing="0">
          <tbody>
            <tr>
              <td style="width:130px;">姓名</td>
              <td>{{adviserArchivesForm.adviserName}} ({{adviserArchivesForm.adviserCode}})</td>
            </tr>
            <tr>
              <td>头像</td>
              <td>
                <el-upload action="#" class="upload-image-one" :auto-upload="false" :on-change="uploadHeadPortrait" :show-file-list="false" accept=".jpg,.jpeg,.png">
                  <img v-if="adviserArchivesForm.headPortrait.val!='--'" :src="adviserArchivesForm.headPortrait.val" alt="">
                  <div class="upload-hover"><i class="el-icon-edit"></i></div>
                </el-upload>
                <span class="warnColor margin-l20" style="vertical-align:bottom;">要求：上传证件照，并且尽量不要使用白底照片！</span>
              </td>
            </tr>
            <tr>
              <td>手机号</td>
              <td>
                <el-input v-if="editFlag==true" v-model="adviserArchivesForm.phone.editVal"></el-input>
                <template v-else-if="adviserArchivesForm.phone.isEdit==true">
                  <el-input v-model="adviserArchivesForm.phone.editVal"></el-input>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','phone')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','phone')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.phone.val}}</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.phone.isEdit=true"></i>
                </template>
              </td>
            </tr>
            <tr>
              <td>邮箱</td>
              <td>
                <el-input v-if="editFlag==true" v-model="adviserArchivesForm.email.editVal"></el-input>
                <template v-else-if="adviserArchivesForm.email.isEdit==true">
                  <el-input v-model="adviserArchivesForm.email.editVal"></el-input>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','email')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','email')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.email.val}}</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.email.isEdit=true"></i>
                </template>
              </td>
            </tr>
            <tr>
              <td>微信二维码</td>
              <td>
                <el-upload action="#" class="upload-image-two" :auto-upload="false" :on-change="uploadQrCodeUrl" :show-file-list="false" accept=".jpg,.jpeg,.png">
                  <img v-if="adviserArchivesForm.qrCodeUrl.val!='--'" :src="adviserArchivesForm.qrCodeUrl.val" alt="">
                  <div class="upload-hover"><i class="el-icon-edit"></i></div>
                </el-upload>
              </td>
            </tr>
            <tr>
              <td>地区</td>
              <td>
                <span>{{adviserArchivesForm.province}}{{adviserArchivesForm.city}}</span>
              </td>
            </tr>
            <tr>
              <td>从业时间</td>
              <td>
                <el-input v-if="editFlag==true" v-model="adviserArchivesForm.experienceTime.editVal">
                  <span slot="suffix" class="table-normal-form-suf">年</span>
                </el-input>
                <template v-else-if="adviserArchivesForm.experienceTime.isEdit==true">
                  <el-input v-model="adviserArchivesForm.experienceTime.editVal">
                    <span slot="suffix" class="table-normal-form-suf">年</span>
                  </el-input>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','experienceTime')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','experienceTime')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.experienceTime.val}}年</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.experienceTime.isEdit=true"></i>
                </template>
              </td>
            </tr>
            <tr>
              <td>已服务客户数量</td>
              <td>
                <el-input v-if="editFlag==true" v-model="adviserArchivesForm.customerCount.editVal">
                  <span slot="suffix" class="table-normal-form-suf">个</span>
                </el-input>
                <template v-else-if="adviserArchivesForm.customerCount.isEdit==true">
                  <el-input v-model="adviserArchivesForm.customerCount.editVal">
                    <span slot="suffix" class="table-normal-form-suf">个</span>
                  </el-input>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','customerCount')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','customerCount')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.customerCount.val}}个</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.customerCount.isEdit=true"></i>
                </template>
              </td>
            </tr>
            <tr>
              <td>现在服务的客户数量</td>
              <td>
                <el-input v-if="editFlag==true" v-model="adviserArchivesForm.newestCount.editVal">
                  <span slot="suffix" class="table-normal-form-suf">个</span>
                </el-input>
                <template v-else-if="adviserArchivesForm.newestCount.isEdit==true">
                  <el-input v-model="adviserArchivesForm.newestCount.editVal">
                    <span slot="suffix" class="table-normal-form-suf">个</span>
                  </el-input>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','newestCount')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','newestCount')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.newestCount.val}}个</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.newestCount.isEdit=true"></i>
                </template>
              </td>
            </tr>
            <tr>
              <td>优势</td>
              <td>
                <el-checkbox-group v-if="editFlag==true" v-model="advantageList" style="width:650px;display:inline-block;">
                  <el-checkbox v-for="(item,ind) in advantageListSel" :key="ind+'sel'" :label="item.label"></el-checkbox>
                </el-checkbox-group>
                <template v-else-if="adviserArchivesForm.advantage.isEdit==true">
                  <el-checkbox-group v-model="advantageList" style="width:650px;display:inline-block;">
                    <el-checkbox v-for="(item,ind) in advantageListSel" :key="ind+'sel1'" :label="item.label"></el-checkbox>
                  </el-checkbox-group>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','advantage')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','advantage')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.advantage.val}}</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.advantage.isEdit=true"></i>
                </template>
              </td>
            </tr>
            <tr>
              <td>资历简介</td>
              <td>
                <el-input v-if="editFlag==true" v-model="adviserArchivesForm.qualification.editVal" type="textarea" autosize style="width:650px;"></el-input>
                <template v-else-if="adviserArchivesForm.qualification.isEdit==true">
                  <el-input v-model="adviserArchivesForm.qualification.editVal" type="textarea" autosize style="width:650px;"></el-input>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','qualification')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','qualification')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.qualification.val}}</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.qualification.isEdit=true"></i>
                </template>
              </td>
            </tr>
            <tr>
              <td>资质证书</td>
              <td>
                <ul class="certificate" v-if="adviserArchivesForm.certificateUrl.length>0">
                  <li v-for="(item,index) in adviserArchivesForm.certificateUrl" :key="'cer'+index">
                    <el-image style="width: 120px; height: 90px" :src="item" fit="scale-down"></el-image>
                    <div class="certificate-opt">
                      <i class="el-icon-zoom-in" @click="onPreview(index)"></i>
                      <i class="el-icon-delete" @click="certificateDel(index)"></i>
                    </div>
                  </li>
                </ul>
                <el-image-viewer v-if="showViewer" :on-close="closeViewer" :initial-index="initInd" :url-list="adviserArchivesForm.certificateUrl" />
                <el-upload action="#" class="upload-image-three" :auto-upload="false" :on-change="uploadCertificateUrl" :show-file-list="false" accept=".jpg,.jpeg,.png">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </td>
            </tr>
            <tr>
              <td>客户服务理念及优势</td>
              <td>
                <el-input v-if="editFlag==true" v-model="adviserArchivesForm.serviceIdea.editVal" type="textarea" autosize style="width:650px;"></el-input>
                <template v-else-if="adviserArchivesForm.serviceIdea.isEdit==true">
                  <el-input v-model="adviserArchivesForm.serviceIdea.editVal" type="textarea" autosize style="width:650px;"></el-input>
                  <i class="fr el-icon-close adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('cancel','serviceIdea')"></i>
                  <i class="fr el-icon-check adviserArchives-icon2" style="line-height:32px" @click="editSingleOpt('sure','serviceIdea')"></i>
                </template>
                <template v-else>
                  <span>{{adviserArchivesForm.serviceIdea.val}}</span>
                  <i class="fr el-icon-edit-outline adviserArchives-icon1" @click="adviserArchivesForm.serviceIdea.isEdit=true"></i>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </el-form>
      <div v-if="editFlag==false" class="text-center margin-t50">
        <el-button type="normal" @click="editAll()">修改资料</el-button>
      </div>
      <div v-else class="text-center margin-t50">
        <el-button type="normal" @click="editAllOpt('sure')">保存</el-button>
        <el-button type="cancel" @click="editAllOpt('cancel')">取消</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  name: "personalData",
  components: { ElImageViewer },
  data () {
    return {
      adviserArchivesForm: {
        adviserName: '',  // 姓名
        adviserCode: '',  // 编号
        headPortrait: { val: '', editVal: '' },  // 头像
        phone: { val: '', editVal: '', isEdit: false },  // 手机号
        email: { val: '', editVal: '', isEdit: false },  // 邮箱
        qrCodeUrl: { val: '', editVal: '' },  // 二维码
        province: '',  // 省份
        city: '',      // 市级
        experienceTime: { val: '', editVal: '', isEdit: false },  // 从业时间
        customerCount: { val: '', editVal: '', isEdit: false },  // 已服务客户数量
        newestCount: { val: '', editVal: '', isEdit: false },  // 现在服务的客户数量
        advantage: { val: '', editVal: '', isEdit: false },   // 优势
        qualification: { val: '', editVal: '', isEdit: false },  // 资历简介
        certificateUrl: [],  // 资质证书
        serviceIdea: { val: '', editVal: '', isEdit: false }   // 客户服务理念及优势
      },
      editFlag: false,  // 编辑 全部
      // 优势
      advantageList: [],
      advantageListSel: [
        { label: '私募基金' },
        { label: '公募基金' },
        { label: '股权配置/组合配置' },
        { label: '基金诊断' }
      ],
      // 资质证书
      showViewer: false,
      initInd: 1,
    }
  },
  mounted () {
    this.getAdviserArchives();
  },
  methods: {
    // 个人资料 获取
    getAdviserArchives () {
      const vm = this;
      vm.$http.post(vm.$apiPath.getInvestmentAdviserArchives, {
        adviserCode: vm.$commonJs.getCookie('code')
      }).then(res => {
        if (res.data.code == 200) {
          // console.log(res);
          let sdata = res.data.data;
          vm.adviserArchivesForm = {
            adviserName: sdata.adviserName,  // 姓名
            adviserCode: sdata.adviserCode,  // 编号
            headPortrait: { val: sdata.headPortrait, editVal: sdata.headPortrait },  // 头像
            phone: { val: sdata.phone, editVal: sdata.phone, isEdit: false },  // 手机号
            email: { val: sdata.email, editVal: sdata.email, isEdit: false },  // 邮箱
            qrCodeUrl: { val: sdata.qrCodeUrl, editVal: sdata.qrCodeUrl },  // 二维码
            province: sdata.province,   // 省份
            city: sdata.city,  // 市级
            experienceTime: { val: sdata.experienceTime, editVal: sdata.experienceTime, isEdit: false },  // 从业时间
            customerCount: { val: sdata.customerCount, editVal: sdata.customerCount, isEdit: false },  // 已服务客户数量
            newestCount: { val: sdata.newestCount, editVal: sdata.newestCount, isEdit: false },  // 现在服务的客户数量
            advantage: { val: sdata.advantage, isEdit: false },   // 优势
            qualification: { val: sdata.qualification, editVal: sdata.qualification, isEdit: false },  // 资历简介
            certificateUrl: sdata.certificateUrl,  // 资质证书
            serviceIdea: { val: sdata.serviceIdea, editVal: sdata.serviceIdea, isEdit: false }   // 客户服务理念及优势
          };
          if (sdata.advantage != '' && sdata.advantage != '--') {
            vm.advantageList = sdata.advantage.split('，');
          }
        }
      })
    },
    // 编辑资料 全部 （手机号、邮箱、从业时间、优势、资历简介、客户服务理念及优势）
    editAll () {
      const vm = this;
      vm.editFlag = true;
      vm.adviserArchivesForm.phone.isEdit = false;
      vm.adviserArchivesForm.email.isEdit = false;
      vm.adviserArchivesForm.experienceTime.isEdit = false;
      vm.adviserArchivesForm.customerCount.isEdit = false;
      vm.adviserArchivesForm.newestCount.isEdit = false;
      vm.adviserArchivesForm.advantage.isEdit = false;
      vm.adviserArchivesForm.qualification.isEdit = false;
      vm.adviserArchivesForm.serviceIdea.isEdit = false;
    },
    editAllOpt (opt) {
      const vm = this;
      if (opt == 'sure') {
        vm.$http.post(vm.$apiPath.updateInvestmentAdviserArchives1, {
          AdviserCode: vm.$commonJs.getCookie('code'),
          Phone: vm.adviserArchivesForm.phone.editVal,
          Email: vm.adviserArchivesForm.email.editVal,
          ExperienceTime: vm.adviserArchivesForm.experienceTime.editVal,
          customerCount: vm.adviserArchivesForm.customerCount.editVal,
          newestCount: vm.adviserArchivesForm.newestCount.editVal,
          Advantage: vm.advantageList.join('，'),
          Qualification: vm.adviserArchivesForm.qualification.editVal,
          ServiceIdea: vm.adviserArchivesForm.serviceIdea.editVal,
        }).then(res => {
          if (res.data.code == 200) {
            vm.adviserArchivesForm.phone.val = vm.adviserArchivesForm.phone.editVal;
            vm.adviserArchivesForm.email.val = vm.adviserArchivesForm.email.editVal;
            vm.adviserArchivesForm.experienceTime.val = vm.adviserArchivesForm.experienceTime.editVal;
            vm.adviserArchivesForm.customerCount.val = vm.adviserArchivesForm.customerCount.editVal;
            vm.adviserArchivesForm.newestCount.val = vm.adviserArchivesForm.newestCount.editVal;
            vm.adviserArchivesForm.advantage.val = vm.advantageList.join('，');
            vm.adviserArchivesForm.qualification.val = vm.adviserArchivesForm.qualification.editVal;
            vm.adviserArchivesForm.serviceIdea.val = vm.adviserArchivesForm.serviceIdea.editVal;
            vm.editFlag = false;
          }
        })
      } else {
        vm.adviserArchivesForm.phone.editVal = vm.adviserArchivesForm.phone.val;
        vm.adviserArchivesForm.email.editVal = vm.adviserArchivesForm.email.val;
        vm.adviserArchivesForm.experienceTime.editVal = vm.adviserArchivesForm.experienceTime.val;
        vm.advantageList = vm.adviserArchivesForm.advantage.val.split('，');
        vm.adviserArchivesForm.qualification.editVal = vm.adviserArchivesForm.qualification.val;
        vm.adviserArchivesForm.serviceIdea.editVal = vm.adviserArchivesForm.serviceIdea.val;
        vm.editFlag = false;
      }
    },
    // 编辑资料 单个
    editSingleOpt (opt, fieldname) {
      const vm = this;
      if (fieldname == 'phone' || fieldname == 'email' || fieldname == 'experienceTime' || fieldname == 'customerCount' || fieldname == 'newestCount' || fieldname == 'qualification' || fieldname == 'serviceIdea') {  // 文本类
        // console.log(vm.adviserArchivesForm[fieldname].val,vm.adviserArchivesForm[fieldname].editVal,vm.adviserArchivesForm[fieldname].isEdit);
        if (opt == 'sure') {
          vm.$http.post(vm.$apiPath.updateInvestmentAdviserArchives, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            FieldName: fieldname,
            Content: vm.adviserArchivesForm[fieldname].editVal
          }).then(res => {
            if (res.data.code == 200) {
              vm.adviserArchivesForm[fieldname].val = vm.adviserArchivesForm[fieldname].editVal;
              vm.adviserArchivesForm[fieldname].isEdit = false;
            }
          })
        } else {
          vm.adviserArchivesForm[fieldname].editVal = vm.adviserArchivesForm[fieldname].val;
          vm.adviserArchivesForm[fieldname].isEdit = false;
        }
      } else if (fieldname == 'advantage') {  // 多选
        if (opt == 'sure') {
          let advantageStr = vm.advantageList.join('，');
          vm.$http.post(vm.$apiPath.updateInvestmentAdviserArchives, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            FieldName: fieldname,
            Content: advantageStr
          }).then(res => {
            if (res.data.code == 200) {
              vm.adviserArchivesForm[fieldname].val = advantageStr;
              vm.adviserArchivesForm[fieldname].isEdit = false;
            }
          })
        } else {
          vm.advantageList = vm.adviserArchivesForm[fieldname].val.split('，');
          vm.adviserArchivesForm[fieldname].isEdit = false;
        }
      } else if (fieldname == 'headPortrait' || fieldname == 'qrCodeUrl') {  // 头像、二维码
        if (opt == 'sure') {
          vm.$http.post(vm.$apiPath.updateInvestmentAdviserArchives, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            FieldName: fieldname,
            Content: vm.adviserArchivesForm[fieldname].editVal
          }).then(res => {
            if (res.data.code == 200) {
              let oldImgUrl = vm.adviserArchivesForm[fieldname].val;
              vm.adviserArchivesForm[fieldname].val = vm.adviserArchivesForm[fieldname].editVal;
              if (oldImgUrl != '' || oldImgUrl !== '--') {    // 删除库中原来的图
                vm.$http.post(vm.$apiPath.deleteImg, {
                  AdviserCode: vm.$commonJs.getCookie('code'),
                  ImgName: oldImgUrl
                }).then(res => { })
              }
            }
          })
        } else {
          vm.adviserArchivesForm[fieldname].editVal = vm.adviserArchivesForm[fieldname].val;
        }
      } else if (fieldname == 'certificateUrl') {  // 资质证书
        if (opt == 'sure') {
          // let newUrlArr=vm.adviserArchivesForm.certificateUrl
          vm.$http.post(vm.$apiPath.updateInvestmentAdviserArchives, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            FieldName: fieldname,
            Content: vm.adviserArchivesForm[fieldname].join(',')
          }).then(res => {
            if (res.data.code == 200) {
              // vm.getAdviserArchives();
            }
          })
        }
      }
    },
    // 文件转base64格式
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    // 上传头像
    uploadHeadPortrait (file, fileList) {
      const vm = this;
      // console.log(file);
      let fileRaw = file.raw;
      let fileName = file.name;
      if (fileName != '') {
        vm.getBase64(fileRaw).then(result => {
          // console.log("base64格式：",result);
          vm.$http.post(vm.$apiPath.uploadImg, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            ImgName: fileName,
            ImgFlow: result
          }).then(res => {
            if (res.data.code == 200) {
              let imgulr = res.data.data.imgUrl;
              vm.adviserArchivesForm.headPortrait.editVal = 'https://www.myfund.com/' + imgulr;
              vm.editSingleOpt('sure', 'headPortrait');
            }
          })
        });
      }
    },
    // 上传二维码
    uploadQrCodeUrl (file, fileList) {
      const vm = this;
      // console.log(file);
      let fileRaw = file.raw;
      let fileName = file.name;
      if (fileName != '') {
        vm.getBase64(fileRaw).then(result => {
          // console.log("base64格式：",result);
          vm.$http.post(vm.$apiPath.uploadImg, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            ImgName: fileName,
            ImgFlow: result
          }).then(res => {
            if (res.data.code == 200) {
              let imgulr = res.data.data.imgUrl;
              vm.adviserArchivesForm.qrCodeUrl.editVal = 'https://www.myfund.com/' + imgulr;
              vm.editSingleOpt('sure', 'qrCodeUrl');
            }
          })
        });
      }
    },
    // 资质证书
    onPreview (index) {
      this.showViewer = true;
      this.initInd = index;
    },
    closeViewer () {
      this.showViewer = false;
    },
    uploadCertificateUrl (file, fileList) {
      const vm = this;
      // console.log(file);
      let fileRaw = file.raw;
      let fileName = file.name;
      if (fileName != '') {
        vm.getBase64(fileRaw).then(result => {
          // console.log("base64格式：", result);
          vm.$http.post(vm.$apiPath.uploadImg, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            ImgName: fileName,
            ImgFlow: result
          }).then(res => {
            if (res.data.code == 200) {
              vm.adviserArchivesForm.certificateUrl.push('https://www.myfund.com/' + res.data.data.imgUrl);
              vm.editSingleOpt('sure', 'certificateUrl');
            }
          })
        });
      }
    },
    certificateDel (index) {
      // console.log(index);
      const vm = this;
      vm.$http.post(vm.$apiPath.deleteImg, {
        AdviserCode: vm.$commonJs.getCookie('code'),
        ImgName: vm.adviserArchivesForm.certificateUrl[index]
      }).then(res => {
        if (res.data.code == 200) {
          vm.adviserArchivesForm.certificateUrl.splice(index, 1);
          vm.editSingleOpt('sure', 'certificateUrl');
        }
      })
    }

  }
}
</script>

<style scoped lang="less">
.adviserArchives {
  &-icon1 {
    float: right;
    font-size: 16px;
    color: #25335a;
    cursor: pointer;
    margin: 0 5px;
  }
  &-icon2 {
    float: right;
    font-size: 16px;
    color: #25335a;
    cursor: pointer;
    margin: 0 5px;
    line-height: 32px;
  }
  .certificate {
    float: left;
    li {
      width: 120px;
      height: 90px;
      float: left;
      margin-right: 10px;
      border: 1px dashed @colorE5;
      position: relative;
      .certificate-opt {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
        color: @wColor;
        font-size: 22px;
        text-align: center;
        display: none;
        i {
          margin: 37px 10px 0;
          cursor: pointer;
        }
      }
    }
    li:hover .certificate-opt {
      display: block;
    }
  }
}
</style>
